import { render } from "./AttachModal.vue?vue&type=template&id=053f23c9&scoped=true"
import script from "./AttachModal.vue?vue&type=script&lang=js"
export * from "./AttachModal.vue?vue&type=script&lang=js"

import "./AttachModal.vue?vue&type=style&index=0&id=053f23c9&scoped=true&lang=css"

import exportComponent from "/var/www/html/lynkto-vlan-user-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-053f23c9"]])

export default __exports__